<template>
  <div class="bq-page" :class="{ 'bq-wireless-page': isMobile }">
    <banner
      class="bq-banner"
      :title="banner.title.loginTitle"
      :subTitle="banner.title.text"
      type="horizontal"
    >
      <!-- <p slot="content" class="bq-banner-text">{{ banner.title.text }}</p> -->
    </banner>

    <SolutionInfo />
    <SectionTitle :title="'核心优势'"></SectionTitle>
    <Advantage />
    <SectionTitle :title="'产品与服务'"></SectionTitle>
    <Service />
    <SectionTitle :title="'合作伙伴'"></SectionTitle>
    <Partner />
  </div>
</template>

<script>
import Banner from '@/components/website_v3/Banner';
import SolutionInfo from '@/components/website_v3/SolutionInfo';
import Advantage from '@/components/website_v3/Advantage';
import Partner from '@/components/website_v3/Partner';
import Service from '@/components/website_v3/Service';
import SectionTitle from '@/components/website_v3/SectionTitle';
// import { isWirelessDevice } from '../../../utils/utils';
import { patterData } from './map';

import { banner } from './home.js';
import { aboutData } from '../About/about.js';

export default {
  name: 'home',

  components: {
    Banner,
    SolutionInfo,
    Advantage,
    Service,
    Partner,
    SectionTitle,
  },

  data() {
    return {
      isMobile: false,
      banner,
      aboutData,
      patterData,
      currentNews: 1,
      currentAbout: 1,
      activeIndex: '1',
    };
  },

  created() {
    // this.isMobile = isWirelessDevice();
  },

  methods: {},
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
